import { ActionsCell as DataGridActionsCell, DeleteActionButton, EditActionButton } from '@procureai/data-grid-ui';
import type { CustomCellRendererProps } from 'ag-grid-react';

import type { SavingsListQuery } from '@/generated/gql/graphql';

type SavingsListRow = SavingsListQuery['savings'][number];

export interface ActionsCellRendererParams {
  onEdit?: (id: string) => void;
  onDelete?: (id: string, name: string) => void;
  editLabel: string;
  deleteLabel: string;
  canModify?: boolean;
}

export const ActionsCellRenderer = ({
  data,
  onEdit,
  onDelete,
  editLabel,
  deleteLabel,
  canModify = true,
}: CustomCellRendererProps<SavingsListRow> & ActionsCellRendererParams) => {
  if (!data || !canModify) return null;

  return (
    <DataGridActionsCell className="gap-1">
      <EditActionButton aria-label={editLabel} tooltip={editLabel} onClick={() => onEdit?.(data.id)} />
      <DeleteActionButton
        aria-label={deleteLabel}
        tooltip={deleteLabel}
        className="text-destructive hover:text-destructive"
        onClick={() => onDelete?.(data.id, data.name ?? '')}
      />
    </DataGridActionsCell>
  );
};
